module.exports = __webpack_public_path__ + "static/media/power_new.cf25f23a.mp3";